import { all } from 'deepmerge';
import * as types from '../action-types';

const { take, call, put, race, delay } = require('redux-saga/effects');

// check if no longer waiting for zones in a home
function* checkNoLongerAwaitingZones({ homeId }) {
  let allZonesPresent = false;
  while (!allZonesPresent) {
    const { data } = yield take([types.WEBSOCKET_LIVE_RECEIVED]);
    console.log('data is', data);
    if (data && data.id === homeId) {
      if (!data.home.awaitingZones) {
        allZonesPresent = true;
      } else {
        console.log('⚠️ a zone with no data still exists', data);
      }
    }
  }
  return allZonesPresent;
}

function* waitForPendingZones() {
  while (true) {
    const action = yield take(types.SET_ZONES_PENDING);
    const waitPeriod = 10000; // no message in 10 seconds? proceed anyway

    const { response, timeout } = yield race({
      response: call(checkNoLongerAwaitingZones, action),
      timeout: delay(waitPeriod),
    });

    if (timeout) {
      console.log('❌ Waiting for pending zones timed out');
    }

    if (response || timeout) {
      yield put({
        ...action,
        type: types.CLEAR_ZONES_PENDING,
      });
    }
  }
}

function* pendingZone() {
  yield all([
    // start the watch queue
    call(waitForPendingZones),
  ]);
}

export default pendingZone;
